module.exports = __webpack_public_path__ + "img/step4.6f701a7d.png";